module.exports = __webpack_public_path__ + "img/main_officialMark.94a71109.svg";